import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {API_MAP} from '../../../core/helpers/api.map';
import {map} from 'rxjs';
import { HotelPageService } from './hotel-page.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const hotelPageResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(HotelPageService)
    .get(API_MAP.hotelPage + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
